import { render } from "./CodeReviewQueue.vue?vue&type=template&id=6ee5fdff&scoped=true"
import script from "./CodeReviewQueue.vue?vue&type=script&lang=js"
export * from "./CodeReviewQueue.vue?vue&type=script&lang=js"

import "./codeReview.css?vue&type=style&index=0&id=6ee5fdff&scoped=true&lang=css&external"
import "./CodeReviewQueue.vue?vue&type=style&index=1&id=6ee5fdff&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ee5fdff"]])

export default __exports__